<template>
    <f7-page
        @page:beforein="pageBeforeIn" @page:afterin="pageAfterIn"
        :page-content="false"
        class="result-page-wrapper">
        <nav-bar></nav-bar>
        <f7-page-content class="result-page-content">
            <div class="result-container">
                <div class="result-card">
                    <!-- Header Banner -->
                    <div class="result-header">
                        <h1 class="header-title">KẾT QUẢ BÀI KIỂM TRA TRỰC TUYẾN</h1>
                        <p class="header-subtitle">HỆ THỐNG THI TRỰC TUYẾN EIC</p>
                    </div>

                    <div class="result-body">
                        <!-- Result Status Box -->
                        <div :class="['status-banner', isPassed ? 'status-pass' : 'status-fail']">
                            <div class="status-badge">
                                <span v-if="isPassed">&#10004; PASSED (ĐÃ ĐẠT)</span>
                                <span v-else>&#10008; FAILED (CHƯA ĐẠT)</span>
                            </div>
                            <h2 class="status-title">{{ isPassed ? 'KẾT QUẢ: ĐÃ ĐẠT' : 'KẾT QUẢ: CHƯA ĐẠT' }}</h2>
                            <p class="status-desc">
                                {{ isPassed 
                                    ? 'Chúc mừng bạn đã hoàn thành xuất sắc bài kiểm tra và đạt chuẩn đánh giá.' 
                                    : 'Rất tiếc bạn chưa đạt điểm chuẩn yêu cầu. Vui lòng ôn tập và thử lại.' }}
                            </p>
                        </div>

                        <!-- KPI Summary Cards -->
                        <div class="kpi-grid">
                            <div class="kpi-card">
                                <div class="kpi-label">Điểm số</div>
                                <div :class="['kpi-value', isPassed ? 'text-pass' : 'text-fail']">
                                    {{ score }}<span class="kpi-sub">/100</span>
                                </div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">Số câu đúng</div>
                                <div class="kpi-value text-dark">
                                    {{ correctQuestions }}<span class="kpi-sub">/{{ totalQuestions }}</span>
                                </div>
                            </div>
                            <div class="kpi-card">
                                <div class="kpi-label">Điểm chuẩn</div>
                                <div class="kpi-value text-primary">
                                    {{ passGrade !== null ? passGrade : '--' }}<span class="kpi-sub">/100</span>
                                </div>
                            </div>
                        </div>

                        <!-- Detailed Information Table -->
                        <div class="info-section">
                            <div class="info-header">Chi tiết bài kiểm tra</div>
                            <div class="info-table">
                                <div class="info-row">
                                    <span class="info-label">Mã tra cứu</span>
                                    <span class="info-val"><span class="code-badge">#{{ userQuiz.id }}</span></span>
                                </div>
                                <div class="info-row alt-bg">
                                    <span class="info-label">Tên bài kiểm tra</span>
                                    <span class="info-val font-semibold">{{ quiz.quizName }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Người kiểm tra</span>
                                    <span class="info-val font-semibold">{{ userInfo.ten }}</span>
                                </div>
                                <div class="info-row alt-bg">
                                    <span class="info-label">Thời gian bắt đầu</span>
                                    <span class="info-val">{{ formatDate(userQuiz.timeBeginQuiz) || '--' }}</span>
                                </div>
                                <div class="info-row">
                                    <span class="info-label">Thời gian nộp bài</span>
                                    <span class="info-val">{{ formatDate(userQuiz.timeEndQuiz) || '--' }}</span>
                                </div>
                                <div class="info-row alt-bg">
                                    <span class="info-label">Thời gian làm bài</span>
                                    <span class="info-val font-medium">{{ duration }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- Action Buttons -->
                        <div class="actions-grid">
                            <f7-button
                                class="btn-review"
                                fill
                                large
                                :href="'/result-detail-quiz/' + this.$f7route.params.userquizId + '/'">
                                <span>XEM ĐÁP ÁN</span>
                            </f7-button>
                            <f7-button
                                class="btn-home"
                                fill
                                large
                                href="/list-quiz/">
                                <span>VỀ TRANG CHỦ</span>
                            </f7-button>
                        </div>
                    </div>
                </div>
            </div>
        </f7-page-content>
    </f7-page>
</template>

<style scoped>
.result-page-wrapper {
    background-color: #f1f5f9 !important;
}

.result-page-content {
    padding: 40px 16px 50px 16px !important;
}

.result-container {
    max-width: 620px;
    margin: 15px auto 30px auto;
}

.result-card {
    background: #ffffff;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.08), 0 8px 10px -6px rgba(0, 0, 0, 0.04);
    border: 1px solid #e2e8f0;
}

.result-header {
    background: linear-gradient(135deg, #093aa5 0%, #0d2566 100%);
    padding: 32px 20px 28px 20px;
    text-align: center;
    color: #ffffff;
}

.header-title {
    margin: 0;
    font-size: 21px;
    font-weight: 700;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: #ffffff;
}

.header-subtitle {
    margin: 8px 0 0 0;
    font-size: 13px;
    color: #93c5fd;
    letter-spacing: 0.3px;
}

.result-body {
    padding: 24px 20px;
}

/* Status Banner */
.status-banner {
    border-radius: 12px;
    padding: 18px 16px;
    text-align: center;
    margin-bottom: 20px;
}

.status-pass {
    background-color: #f0fdf4;
    border: 1.5px solid #86efac;
}

.status-fail {
    background-color: #fef2f2;
    border: 1.5px solid #fca5a5;
}

.status-badge {
    display: inline-block;
    color: #ffffff;
    font-size: 12px;
    font-weight: 700;
    padding: 4px 14px;
    border-radius: 20px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.status-pass .status-badge {
    background-color: #16a34a;
}

.status-fail .status-badge {
    background-color: #dc2626;
}

.status-title {
    margin: 4px 0 6px 0;
    font-size: 18px;
    font-weight: 700;
}

.status-pass .status-title {
    color: #15803d;
}

.status-fail .status-title {
    color: #991b1b;
}

.status-desc {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
}

.status-pass .status-desc {
    color: #166534;
}

.status-fail .status-desc {
    color: #7f1d1d;
}

/* KPI Grid */
.kpi-grid {
    display: flex;
    gap: 12px;
    margin-bottom: 20px;
}

.kpi-card {
    flex: 1;
    background-color: #f8fafc;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 14px 8px;
    text-align: center;
}

.kpi-label {
    font-size: 11px;
    font-weight: 600;
    color: #64748b;
    text-transform: uppercase;
    margin-bottom: 4px;
}

.kpi-value {
    font-size: 22px;
    font-weight: 800;
    line-height: 1.2;
}

.kpi-sub {
    font-size: 13px;
    font-weight: 500;
    color: #64748b;
}

.text-pass {
    color: #16a34a;
}

.text-fail {
    color: #dc2626;
}

.text-dark {
    color: #0f172a;
}

.text-primary {
    color: #0284c7;
}

/* Info Section */
.info-section {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 24px;
}

.info-header {
    background-color: #f8fafc;
    padding: 12px 16px;
    border-bottom: 1px solid #e2e8f0;
    font-size: 13px;
    font-weight: 700;
    color: #334155;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.info-table {
    display: flex;
    flex-direction: column;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    border-bottom: 1px solid #f1f5f9;
    font-size: 14px;
}

.info-row:last-child {
    border-bottom: none;
}

.alt-bg {
    background-color: #fafbfc;
}

.info-label {
    color: #64748b;
    font-weight: 500;
    flex: 1;
}

.info-val {
    color: #0f172a;
    text-align: right;
    flex: 1.5;
    word-break: break-word;
}

.font-semibold {
    font-weight: 600;
}

.font-medium {
    font-weight: 500;
}

.code-badge {
    background-color: #e0f2fe;
    color: #0369a1;
    padding: 3px 8px;
    border-radius: 4px;
    font-family: monospace;
    font-size: 13px;
    font-weight: 700;
}

/* Actions */
.actions-grid {
    display: flex;
    gap: 12px;
}

.btn-review {
    flex: 1;
    background-color: #f59e0b !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-transform: uppercase !important;
    font-size: 14px !important;
    box-shadow: 0 2px 6px rgba(245, 158, 11, 0.25) !important;
}

.btn-home {
    flex: 1;
    background-color: #16a34a !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    border-radius: 8px !important;
    height: 44px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-transform: uppercase !important;
    font-size: 14px !important;
    box-shadow: 0 2px 6px rgba(22, 163, 74, 0.25) !important;
}

@media (max-width: 480px) {
    .actions-grid {
        flex-direction: column;
    }
}
</style>

<script>
    import axios from "axios";
    import apiEndpoint from "../../apiEndpoint.js"
    import NavBar from './NavBar.vue';
    var dateFns = require("date-fns");
    export default {
        components : {
            NavBar,
        },
        data() {
            return {
                totalQuestions: 0,
                correctQuestions: 0,
                apiUrl: apiEndpoint + "api/UserQuizzes",
                dataFromAPI: [],
                userQuiz: {},
                passGrade: null,
                resultUserQuiz: '',
                userInfo: {},
                quiz: {},
            };
        },
        computed: {
            score() {
                return this.totalQuestions > 0 ? Math.floor((this.correctQuestions / this.totalQuestions) * 100) : 0;
            },
            isPassed() {
                return this.passGrade !== null && this.passGrade !== undefined && this.score >= this.passGrade;
            },
            duration() {
                if (this.userQuiz && this.userQuiz.timeBeginQuiz && this.userQuiz.timeEndQuiz) {
                    return this.getThoiGianThi(this.userQuiz);
                }
                return '--';
            }
        },
        methods : {
            toHHMMSS(sec_num) {
                // var sec_num = parseInt(second, 10); // don't forget the second param
                var hours   = Math.floor(sec_num / 3600);
                var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
                var seconds = sec_num - (hours * 3600) - (minutes * 60);

                if (hours   < 10) {hours   = "0"+hours;}
                if (minutes < 10) {minutes = "0"+minutes;}
                if (seconds < 10) {seconds = "0"+seconds;}
                return hours+':'+minutes+':'+seconds;
            },
            getThoiGianThi(myUserQuiz){
                let time = new Date(myUserQuiz.timeEndQuiz) - new Date(myUserQuiz.timeBeginQuiz);
                time = this.toHHMMSS(Math.floor(time / 1000));
                return time;
            },
            formatDate(date){
                if(!date) return;
                return dateFns.format(new Date(date),'dd/MM/yyyy HH:mm:ss')
            },
            setAxiosGlobal(token) {
                axios.defaults.headers = { 'Authorization': token };
            },
            async getResultUserQuiz(){
                if (this.userQuiz && this.userQuiz.quizId !== undefined) {
                    this.passGrade = await this.getpassGrade(this.userQuiz.quizId);
                }
                if(this.totalQuestions > 0 && Math.floor(this.correctQuestions/this.totalQuestions *100)>=this.passGrade){
                    this.resultUserQuiz = '<span style="color: #28a745 ">PASS</span>';
                }else{
                    this.resultUserQuiz = '<span style="color: #e91e63 ">FAIL</span>';
                }
            },
            async getpassGrade(quizId){
                let passGrade = 0;
                if (quizId === undefined || quizId === null) return passGrade;
                try {
                    let filter = {
                        where: {
                            id: quizId
                        }
                    };
                    let data = await axios.get(apiEndpoint + "api/Quizzes", {
                        params: {
                            filter: filter
                        }
                    });
                    if (data.data && data.data.length > 0) {
                        this.quiz = data.data[0];
                        passGrade = this.quiz.passGrade;
                    }
                } catch (error) {
                    console.log(error);
                }
                return passGrade;
            },
            pageBeforeIn: function (e, page) {
                const app = this.$f7;
                app
                    .preloader
                    .hide();
            },
            pageAfterIn: function (e, page) {
                const app = this.$f7;
                app
                    .preloader
                    .hide();
            },
            onPageBeforeRemove() {
                const self = this;
                if (self.popup)
                    self.popup.destroy();
                }
            ,
            async getUserQuiz() {
                let filter = {
                    where: {
                        id: this.$f7route.params.userquizId
                    }
                };
                try {
                    let data = await axios.get(this.apiUrl, {
                        params: {
                            filter: filter
                        }
                    });
                    this.dataFromAPI = data.data;
                    this.userQuiz = this.dataFromAPI[0];
                    this.totalQuestions = this.userQuiz.listQuestions.length;
                    this.correctQuestions = this.userQuiz.correctQuestions;

                } catch (error) {
                    console.log(error);
                }

            },
            async sendEmail(){
                let urlSendMail = apiEndpoint + "api/ContactLists/sendEmail2";
                
                const quizName = (this.quiz && this.quiz.quizName) ? this.quiz.quizName : 'Bài kiểm tra';
                const userName = (this.userInfo && this.userInfo.ten) ? this.userInfo.ten : 'Thí sinh';
                const userEmail = (this.userInfo && this.userInfo.email) ? this.userInfo.email : '';
                const quizId = (this.userQuiz && this.userQuiz.id) ? this.userQuiz.id : '';
                const timeBegin = (this.userQuiz && this.userQuiz.timeBeginQuiz) ? this.formatDate(this.userQuiz.timeBeginQuiz) : '--';
                const timeEnd = (this.userQuiz && this.userQuiz.timeEndQuiz) ? this.formatDate(this.userQuiz.timeEndQuiz) : '--';
                const duration = (this.userQuiz && this.userQuiz.timeBeginQuiz && this.userQuiz.timeEndQuiz) ? this.getThoiGianThi(this.userQuiz) : '--';
                
                const totalQ = this.totalQuestions || 0;
                const correctQ = this.correctQuestions || 0;
                const score = totalQ > 0 ? Math.floor((correctQ / totalQ) * 100) : 0;
                const passScore = (this.passGrade !== null && this.passGrade !== undefined) ? this.passGrade : 0;
                const isPassed = score >= passScore;

                const statusColor = isPassed ? "#16a34a" : "#dc2626";
                const statusBg = isPassed ? "#f0fdf4" : "#fef2f2";
                const statusBorder = isPassed ? "#86efac" : "#fca5a5";
                const statusBadgeBg = isPassed ? "#16a34a" : "#dc2626";
                const statusBadgeText = isPassed ? "&#10004; PASSED (ĐẠT)" : "&#10008; FAILED (CHƯA ĐẠT)";
                const statusTitle = isPassed ? "KẾT QUẢ: ĐẠT" : "KẾT QUẢ: CHƯA ĐẠT";
                const statusTitleColor = isPassed ? "#15803d" : "#991b1b";
                const statusDescColor = isPassed ? "#166534" : "#7f1d1d";
                const statusDesc = isPassed 
                    ? "Chúc mừng bạn đã hoàn thành xuất sắc bài kiểm tra và đạt chuẩn đánh giá." 
                    : "Rất tiếc bạn chưa đạt điểm chuẩn yêu cầu. Vui lòng ôn tập và thử lại.";

                let emailItem = {
                    to: this.userInfo.email,
                    from: 'exam.eic.com.vn <admin@eic.com.vn>',
                    subject: `[EIC Exam] Kết quả bài kiểm tra: ${quizName} (Mã tra cứu: #${quizId})`,
                    text: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml" lang="vi">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Kết Quả Bài Kiểm Tra - EIC</title>
</head>
<body style="margin: 0; padding: 0; background-color: #f1f5f9; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; -webkit-font-smoothing: antialiased; -webkit-text-size-adjust: 100%;">
  <table width="100%" cellpadding="0" cellspacing="0" border="0" style="background-color: #f1f5f9; padding: 30px 10px;">
    <tr>
      <td align="center">
        <!-- Main Card -->
        <table width="100%" cellpadding="0" cellspacing="0" border="0" style="max-width: 600px; background-color: #ffffff; border-radius: 12px; overflow: hidden; box-shadow: 0 4px 20px rgba(0,0,0,0.07); border: 1px solid #e2e8f0;">
          
          <!-- Header Banner -->
          <tr>
            <td align="center" style="background: linear-gradient(135deg, #093aa5 0%, #0d2566 100%); background-color: #093aa5; padding: 28px 20px 24px 20px; color: #ffffff;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td align="center" style="padding-bottom: 14px;">
                    <img src="https://raw.githubusercontent.com/quangvietntd/media/refs/heads/main/logo_eic.png" alt="EIC Logo" width="180" style="max-width: 180px; height: auto; display: block; border: 0; outline: none; text-decoration: none;" />
                  </td>
                </tr>
                <tr>
                  <td align="center" style="padding: 0;">
                    <h1 style="margin: 0; font-size: 20px; font-weight: 700; letter-spacing: 0.5px; text-transform: uppercase; color: #ffffff; line-height: 1.3;">KẾT QUẢ BÀI KIỂM TRA TRỰC TUYẾN</h1>
                    <p style="margin: 6px 0 0 0; font-size: 13px; color: #93c5fd; letter-spacing: 0.3px;">HỆ THỐNG THI TRỰC TUYẾN EIC</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Result Status Box -->
          <tr>
            <td style="padding: 24px 24px 16px 24px;">
              <div style="background-color: ${statusBg}; border: 1.5px solid ${statusBorder}; border-radius: 10px; padding: 18px 20px; text-align: center;">
                <div style="display: inline-block; background-color: ${statusBadgeBg}; color: #ffffff; font-size: 12px; font-weight: 700; padding: 4px 14px; border-radius: 20px; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 8px;">
                  ${statusBadgeText}
                </div>
                <h2 style="margin: 4px 0 4px 0; color: ${statusTitleColor}; font-size: 18px; font-weight: 700;">${statusTitle}</h2>
                <p style="margin: 0; color: ${statusDescColor}; font-size: 13px; line-height: 1.5;">${statusDesc}</p>
              </div>
            </td>
          </tr>

          <!-- KPI Summary Badges (3 Columns) -->
          <tr>
            <td style="padding: 0 24px 20px 24px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td width="31%" style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 14px 6px; text-align: center; vertical-align: middle;">
                    <div style="font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; margin-bottom: 4px;">Điểm số</div>
                    <div style="font-size: 22px; font-weight: 800; color: ${statusColor}; line-height: 1.2;">${score}<span style="font-size: 13px; font-weight: 500; color: #64748b;">/100</span></div>
                  </td>
                  <td width="3.5%">&nbsp;</td>
                  <td width="31%" style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 14px 6px; text-align: center; vertical-align: middle;">
                    <div style="font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; margin-bottom: 4px;">Số câu đúng</div>
                    <div style="font-size: 22px; font-weight: 800; color: #0f172a; line-height: 1.2;">${correctQ}<span style="font-size: 13px; font-weight: 500; color: #64748b;">/${totalQ}</span></div>
                  </td>
                  <td width="3.5%">&nbsp;</td>
                  <td width="31%" style="background-color: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 14px 6px; text-align: center; vertical-align: middle;">
                    <div style="font-size: 11px; font-weight: 600; color: #64748b; text-transform: uppercase; margin-bottom: 4px;">Điểm chuẩn</div>
                    <div style="font-size: 22px; font-weight: 800; color: #0284c7; line-height: 1.2;">${passScore}<span style="font-size: 13px; font-weight: 500; color: #64748b;">/100</span></div>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Detailed Information Table -->
          <tr>
            <td style="padding: 0 24px 24px 24px;">
              <table width="100%" cellpadding="0" cellspacing="0" border="0" style="border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;">
                <tr style="background-color: #f8fafc;">
                  <td colspan="2" style="padding: 10px 16px; border-bottom: 1px solid #e2e8f0;">
                    <strong style="font-size: 13px; color: #334155; text-transform: uppercase; letter-spacing: 0.5px;">Chi tiết bài kiểm tra</strong>
                  </td>
                </tr>
                <tr style="border-bottom: 1px solid #f1f5f9;">
                  <td style="padding: 10px 16px; color: #64748b; width: 40%; font-size: 13px; font-weight: 500; border-bottom: 1px solid #f1f5f9;">Mã tra cứu</td>
                  <td style="padding: 10px 16px; color: #0f172a; font-weight: 700; border-bottom: 1px solid #f1f5f9;">
                    <span style="background-color: #e0f2fe; color: #0369a1; padding: 3px 8px; border-radius: 4px; font-family: monospace; font-size: 13px;">#${quizId}</span>
                  </td>
                </tr>
                <tr style="background-color: #fafbfc;">
                  <td style="padding: 10px 16px; color: #64748b; font-size: 13px; font-weight: 500; border-bottom: 1px solid #f1f5f9;">Tên bài kiểm tra</td>
                  <td style="padding: 10px 16px; color: #0f172a; font-weight: 600; font-size: 14px; border-bottom: 1px solid #f1f5f9;">${quizName}</td>
                </tr>
                <tr>
                  <td style="padding: 10px 16px; color: #64748b; font-size: 13px; font-weight: 500; border-bottom: 1px solid #f1f5f9;">Thí sinh</td>
                  <td style="padding: 10px 16px; color: #0f172a; font-weight: 600; font-size: 14px; border-bottom: 1px solid #f1f5f9;">${userName}</td>
                </tr>
                <tr style="background-color: #fafbfc;">
                  <td style="padding: 10px 16px; color: #64748b; font-size: 13px; font-weight: 500; border-bottom: 1px solid #f1f5f9;">Thời gian bắt đầu</td>
                  <td style="padding: 10px 16px; color: #334155; font-size: 13px; border-bottom: 1px solid #f1f5f9;">${timeBegin}</td>
                </tr>
                <tr>
                  <td style="padding: 10px 16px; color: #64748b; font-size: 13px; font-weight: 500; border-bottom: 1px solid #f1f5f9;">Thời gian nộp bài</td>
                  <td style="padding: 10px 16px; color: #334155; font-size: 13px; border-bottom: 1px solid #f1f5f9;">${timeEnd}</td>
                </tr>
                <tr style="background-color: #fafbfc;">
                  <td style="padding: 10px 16px; color: #64748b; font-size: 13px; font-weight: 500;">Thời gian làm bài</td>
                  <td style="padding: 10px 16px; color: #334155; font-size: 13px; font-weight: 600;">${duration}</td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Action Button CTA -->
          <tr>
            <td align="center" style="padding: 0 24px 28px 24px;">
              <table cellpadding="0" cellspacing="0" border="0">
                <tr>
                  <td align="center" style="background-color: #093aa5; border-radius: 6px;">
                    <a href="https://exam.eic.com.vn" target="_blank" style="display: inline-block; background-color: #093aa5; color: #ffffff; text-decoration: none; padding: 12px 28px; border-radius: 6px; font-weight: 600; font-size: 14px; letter-spacing: 0.3px;">Truy Cập Hệ Thống EIC Exam &rarr;</a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background-color: #f8fafc; border-top: 1px solid #e2e8f0; padding: 20px 24px; text-align: center; font-size: 12px; color: #94a3b8; line-height: 1.6;">
              <p style="margin: 0 0 6px 0;">Email này được tạo và gửi tự động từ <strong>Hệ Thống Thi Trực Tuyến EIC</strong>.</p>
              <p style="margin: 0 0 8px 0;">Mọi thắc mắc vui lòng liên hệ: <a href="mailto:it@eic.com.vn" style="color: #093aa5; text-decoration: none; font-weight: 600;">it@eic.com.vn</a> | Website: <a href="https://exam.eic.com.vn" target="_blank" style="color: #093aa5; text-decoration: none; font-weight: 600;">exam.eic.com.vn</a></p>
              <p style="margin: 0; font-size: 11px; color: #cbd5e1;">&copy; 2026 EIC Corporation. All rights reserved.</p>
            </td>
          </tr>

        </table>
      </td>
    </tr>
  </table>
</body>
</html>`
                };
                console.log('viet emailItem',emailItem);
                try{
                    axios.post(urlSendMail,emailItem).then(res => console.log(res.status));
                }catch(err){
                    alert(err);
                }
            },
        },
       
        async created() {
            let token = localStorage.getItem('eic_quiz_tokenKey');
            this.setAxiosGlobal(token);
            this.userInfo = JSON.parse(localStorage.getItem('eic_quiz_userInfo'));
            await this.getUserQuiz();
            await this.getResultUserQuiz();
            await this.sendEmail();
        }
    };
</script>
